import React, { useContext, useEffect, useState } from 'react';
import { StateContext } from '../StateContainer';
import axios from 'axios';
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import TransferAssistant from './PhoneAgentComponents/TransferAssistant';
import { Nations, availableLanguages } from './PhoneAgentComponents/Nations';

const PhoneAgentConfiguration = ({ progetto }) => {
  const { id } = useParams();
  const { setLoading, setError, token, setAggiornamentoDatiProgetto } =
    useContext(StateContext);

  console.log(progetto);

  let phoneAgentDefaultConfiguration = {
    name: '',
    instructions: '',
    firstMessage: '',
    defaultLanguage: 'it',
    additionalLanguages: [],
    twilio: {
      label: '',
      phoneNumber: '',
      twilioSid: '',
      twilioAuthToken: '',
    },
    transferToNumber: [],
    transferToAgent: [],
  };

  const [phoneAgentConfigurationDetail, setPhoneAgentConfigurationDetail] =
    useState(progetto[0]?.phoneAgentDetails);

  const AggiornaAgenteTelefonico = (event) => {
    event.preventDefault();
    setLoading(true);
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/project/update`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        projectCode: id,
        phoneAgentDetails: phoneAgentConfigurationDetail,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('tokenExpiration');
          window.location.replace('/login');
        } else if (response.status === 200) {
          setLoading(false);
          setAggiornamentoDatiProgetto(response.status);
        }
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };

  const optionsWithFlags = availableLanguages.map((lang) => ({
    value: lang.short,
    label: `${lang.flag} ${lang.language}`,
    data: lang,
  }));

  const options = Nations.map((nation) => ({
    value: nation.phoneCode,
    label: `${nation.flagEmoji} ${nation.name} (${nation.phoneCode})`,
  }));

  console.log(phoneAgentConfigurationDetail);

  return (
    <div>
      {/* Nome Agente  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <label className="form-label" htmlFor="titoloProg">
            Nome dell'agente
          </label>
          <input
            type="text"
            id="titoloProg"
            className="form-control form-control-lg fs-6"
            value={phoneAgentConfigurationDetail.name || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                name: event.target.value,
              }))
            }
          />
        </div>
      </div>

      {/* Lingua default Agente  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <div className="row">
            <div className="col-8">
              <label className="form-label" htmlFor="titoloProg">
                Lingua Agente
              </label>
              <p>
                Scegli la lingua principale in cui comunicherà l’assistente
                telefonico.
              </p>
            </div>
            <div className="col-4">
              <Select
                options={optionsWithFlags}
                value={optionsWithFlags.find(
                  (opt) =>
                    opt.value === phoneAgentConfigurationDetail.defaultLanguage
                )}
                onChange={(selectedOption) =>
                  setPhoneAgentConfigurationDetail((prev) => ({
                    ...prev,
                    defaultLanguage: selectedOption?.value || '',
                  }))
                }
                placeholder="Seleziona lingua"
                noOptionsMessage={() => 'Nessun risultato trovato'}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Altre lingue agente  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <div className="row">
            <div className="col-12">
              <label className="form-label" htmlFor="titoloProg">
                Lingue Aggiuntive
              </label>
              <p>
                Specifica lingue alternative che il chiamante può selezionare
                durante la chiamata.
              </p>

              <div className="my-3">
                <Select
                  isMulti
                  options={optionsWithFlags}
                  value={phoneAgentConfigurationDetail.additionalLanguages}
                  onChange={(selectedOptions) =>
                    setPhoneAgentConfigurationDetail((prev) => ({
                      ...prev,
                      additionalLanguages: selectedOptions,
                    }))
                  }
                  placeholder="Seleziona lingue aggiuntive"
                  noOptionsMessage={() => 'Nessun risultato trovato'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Primo Messaggio  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <label className="form-label" htmlFor="titoloProg">
            Primo Messaggio
          </label>
          <textarea
            type="text"
            placeholder="Dai istruzioni al tuo bot su cosa dovrebbe fare (esempio: sei l'assistente dell'azienda Gamma, rispondi alle domande degli utenti)"
            id="istruzioniChatbot"
            className="form-control form-control-lg fs-6"
            style={{
              // maxHeight: "250px",
              minHeight: '220px',
              // overflowY: "hidden",
            }}
            value={phoneAgentConfigurationDetail.firstMessage || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                firstMessage: event.target.value,
              }))
            }
          />
        </div>
      </div>

      {/* Istruzioni agente  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <label className="form-label" htmlFor="titoloProg">
            Istruzioni agente
          </label>
          <p>
            Il prompt di sistema viene utilizzato per determinare la personalità
            dell’assistente e il contesto della conversazione.
          </p>
          <textarea
            type="text"
            placeholder="Dai istruzioni al tuo bot su cosa dovrebbe fare (esempio: sei l'assistente dell'azienda Gamma, rispondi alle domande degli utenti)"
            id="istruzioniChatbot"
            className="form-control form-control-lg fs-6"
            style={{
              // maxHeight: "250px",
              minHeight: '220px',
              // overflowY: "hidden",
            }}
            value={phoneAgentConfigurationDetail.instructions || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                instructions: event.target.value,
              }))
            }
          />
        </div>
      </div>

      {/* Assistente Twilio  */}
      <div className="card my-3 border-0">
        <div className="card-body h-100 phone-agent-card-color rounded-3">
          <h6 className="form-label font-size-18" htmlFor="titoloProg">
            Integrazione Twilio
          </h6>
          <label className="form-label mt-2" htmlFor="formControlLgcvv">
            Label
          </label>
          <input
            type="text"
            id="formControlLgcvv"
            className="form-control form-control-lg fs-6"
            placeholder="Inserisci il titolo del progetto"
            value={phoneAgentConfigurationDetail?.twilio?.label || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                twilio: {
                  ...prev.twilio,
                  label: event.target.value,
                },
              }))
            }
          />

          <div className="row my-3">
            <label className="form-label" htmlFor="formControlLgcvv">
              Numero di telefono
            </label>

            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Numero di Telefono"
                value={phoneAgentConfigurationDetail?.twilio?.phoneNumber || ''}
                onChange={(event) =>
                  setPhoneAgentConfigurationDetail((prev) => ({
                    ...prev,
                    twilio: {
                      ...prev.twilio,
                      phoneNumber: event.target.value,
                    },
                  }))
                }
              />
            </div>
          </div>

          <label className="form-label mt-2" htmlFor="formControlLgcvv">
            Twilio SID
          </label>
          <input
            type="text"
            id="formControlLgcvv"
            className="form-control form-control-lg fs-6"
            placeholder="Inserisci il titolo del progetto"
            value={phoneAgentConfigurationDetail?.twilio?.twilioSid || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                twilio: {
                  ...prev.twilio,
                  twilioSid: event.target.value,
                },
              }))
            }
          />

          <label className="form-label mt-3" htmlFor="formControlLgcvv">
            Twilio Auth Token
          </label>
          <input
            type="text"
            id="formControlLgcvv"
            className="form-control form-control-lg fs-6"
            placeholder="Inserisci il titolo del progetto"
            value={phoneAgentConfigurationDetail?.twilio?.twilioAuthToken || ''}
            onChange={(event) =>
              setPhoneAgentConfigurationDetail((prev) => ({
                ...prev,
                twilio: {
                  ...prev.twilio,
                  twilioAuthToken: event.target.value,
                },
              }))
            }
          />
        </div>
      </div>

      {/* Trasferimento a numero / agente navbar  */}
      <TransferAssistant
        phoneAgentConfigurationDetail={phoneAgentConfigurationDetail}
        setPhoneAgentConfigurationDetail={setPhoneAgentConfigurationDetail}
      />

      {/* Istruzioni agente  */}
      <div className="col-12 d-flex align-items-center gap-2 justify-content-center justify-content-lg-end my-3">
        {/* <a href='' className='btn bg-rosso text-white'>
            Cancella
          </a> */}
        <a
          href=""
          className="btn bg-green-second text-white"
          onClick={(event) => AggiornaAgenteTelefonico(event)}
        >
          Aggiorna
        </a>
      </div>
    </div>
  );
};

export default PhoneAgentConfiguration;
